// extracted by mini-css-extract-plugin
module.exports = {"title":"Leaderboard_title__46fJo","display":"Leaderboard_display__2jGE9"};